import React from "react";
import './benefits.css';

// ....... images .......
import benefit1 from '../../../../assets/images/solution1.svg';
import benefit2 from '../../../../assets/images/solution2.svg';
import benefit3 from '../../../../assets/images/solution3.svg';


function Benefits() {
   return (
       <div className="content-box width-1000">
          <div className="benefit-main-title white-color rubik-medium text-align-center margin-b-40">Benefits</div>
          <ul className="benefits">
             <li className="flex hr-space-between">
                <div className="benefit-content">
                   <div className="small-title margin-b-20">
                      Improve your landing page conversions
                   </div>
                   <div className="description">
                      Provide your viewers with an interactive intro, clear call-to-actions and an easy way to take
                      further action. Deliver higher quality leads.
                   </div>
                </div>
                <div className="benefit-img icon">
                   <img src={benefit1} alt=""/>
                </div>
             </li>
             <li className="flex hr-space-between">
                <div className="benefit-img icon">
                   <img src={benefit2} alt=""/>
                </div>
                <div className="benefit-content">
                   <div className="small-title margin-b-20">
                      Stand-out with your content marketing
                   </div>
                   <div className="description">
                      No more sterile blogs, no more verbose emails that go straight to spam. Make those blogs and
                      emails more engaging, include an interactive video or a product tour to show off your product’s
                      superpowers.
                   </div>
                </div>
             </li>
             <li className="flex hr-space-between">
                <div className="benefit-content">
                   <div className="small-title margin-b-20">
                      Increase new feature adoption
                   </div>
                   <div className="description">
                      Create an engaging experience for your users to try new features via an interactive walkthrough
                      and an accompanying how-to-guide.
                   </div>
                </div>
                <div className="benefit-img icon">
                   <img src={benefit3} alt=""/>
                </div>
             </li>
          </ul>
       </div>
   )
}

export default Benefits;
